import { createContext, useReducer, Dispatch, ReactNode } from "react";

// Definimos los tipos
type DarkModeActionType = "LIGHT" | "DARK" | "TOGGLE";

interface DarkModeAction {
  type: DarkModeActionType;
}

interface DarkModeContextType {
  darkMode: boolean;
  dispatch: Dispatch<DarkModeAction>;
}

// Estado inicial tipado
const INITIAL_STATE: DarkModeContextType = {
  darkMode: false,
  dispatch: () => null, // Valor inicial para dispatch
};

// Creamos el contexto con el tipo correcto
export const DarkModeContext = createContext<DarkModeContextType>(INITIAL_STATE);

interface DarkModeProviderProps {
  children: ReactNode;
}

// Reducer tipado
const DarkModeReducer = (state: { darkMode: boolean }, action: DarkModeAction) => {
  switch (action.type) {
    case "LIGHT":
      return {
        darkMode: false,
      };
    case "DARK":
      return {
        darkMode: true,
      };
    case "TOGGLE":
      return {
        darkMode: !state.darkMode,
      };
    default:
      return state;
  }
};

export const DarkModeContextProvider: React.FC<DarkModeProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(DarkModeReducer, { darkMode: INITIAL_STATE.darkMode });

  return (
    <DarkModeContext.Provider 
      value={{ 
        darkMode: state.darkMode, 
        dispatch 
      }}
    >
      {children}
    </DarkModeContext.Provider>
  );
};

export default DarkModeReducer;